// @ts-nocheck
/**
 * HTML Renderer - Generates HTML for products
 */
class ShopifyHTMLRenderer {
  /**
   * @param {any} variantDetector - Variant detector instance
   * @param {any} priceCalculator - Price calculator instance
   */
  constructor(variantDetector, priceCalculator) {
    this.variantDetector = variantDetector;
    this.priceCalculator = priceCalculator;
  }

  /**
   * @param {Product} product - The product object
   * @returns {string} HTML string
   */
  generateFormatButtons(product) {
    // Use the new dynamic approach - get all unique formats
    const uniqueFormats = this.variantDetector.getUniqueFormats(product);
    const formats = [];

    // For each unique format, create a format button
    uniqueFormats.forEach(formatName => {
      const price = this.priceCalculator.getLowestPriceForFormat(
        product,
        formatName
      );

      if (price) {
        formats.push({
          format: formatName.toLowerCase(),
          label: formatName, // Use the actual format name from Shopify
          price: price,
        });
      }
    });

    // Use the smart variant detector logic to determine if format buttons are needed
    const isSimpleProduct = this.variantDetector.isSimpleProduct(product);

    // If this is a simple product (no complex variant structure), no format buttons needed
    if (isSimpleProduct) {
      return ''; // Return empty string - no format buttons for simple products
    }

    return formats
      .map(formatData => this._renderFormatButton(formatData, product))
      .join('');
  }

  /**
   * @param {Product} product - The product object
   * @returns {string} HTML string
   */
  async generatePurchaseOptions(typeName, product, sectionData) {
    
    if (this.variantDetector.isSimpleProduct(product)) {
        return await this._generateSimpleProductPurchaseOptions(product,sectionData);
    }

    const defaultFormat = this._getDefaultFormat(product);
    
    if (!defaultFormat) {
        return this._renderNoOptionsMessage();
    }

    /** @type {Record<string, any[]>} */
    const variantsByType = {};
    
    if (product.variants) {
        
        product.variants
            .filter(variant =>
                variant.option1?.toLowerCase().includes(typeName.toLowerCase())
            )
            .forEach(variant => {
                const type = variant.option2 || 'Buy';
                if (!variantsByType[type]) variantsByType[type] = [];
                variantsByType[type].push(variant);
            });
    }

    if (Object.keys(variantsByType).length === 0) {
        return this._renderNoOptionsMessage();
    }
     /*
      comment 
      FMVP-1051 For SKUs with cm_rental.rental_only_sku = "true" then do not display "Buy Used" or "Buy New" 
    */
    let hasRentalOnlySku = false;
    for (const type of Object.keys(variantsByType)) {
      if (variantsByType[type].some(variant => 
        variant.metafields.some(metafield => 
            metafield.namespace === "cm_rental" && 
            (metafield.rental_only_sku === "true" || metafield.rental_only_sku === true)
        )
      )) {
        hasRentalOnlySku = true;
        break;
      }
    }
    if (hasRentalOnlySku) {
      delete variantsByType["Buy New"];
      delete variantsByType["Buy Used"];
    }
    const retObj = await Promise.all(
        Object.keys(variantsByType).map(async type => {
          const variants = variantsByType[type];
          if(typeName == "Print"){
            if(product.metafields?.new_book_only_on_efollett_flag != "false" && product.metafields?.new_book_only_on_efollett_flag != false){
              if(variants[0].option2.includes("Used")) {
                //console.log("NOT SHOW VARIANT (Used)")
              }else{
                return variants
                  ? await this._renderPurchaseOption(type, variants, product, sectionData)
                  : '';
              }
            }else{
              
              if (!variants[0].available && variants[0].option2 == "Buy New") {
                const hasBuyUsedAvailable = product.variants.some(variant => 
                  variant.option2 === "Buy Used" && variant.available === true && variant.option1 === "Print"
                );
                if (hasBuyUsedAvailable) {
                  //console.log("NOT SHOW VARIANT (Buy New) Out of Stock if we have a BUY USED available")
                }else{
                  //console.log("SHOW VARIANT (Buy New) Out of Stock if we have a BUY USED unavailable")
                  return variants
                    ? await this._renderPurchaseOption(type, variants, product, sectionData)
                    : '';
                }
              }else if(!variants[0].available && variants[0].option2 == "Buy Used") {
                const hasBuyNewAvailable = product.variants.some(variant => 
                  variant.option2 === "Buy New" && variant.available === true && variant.option1 === "Print"
                );
                if (hasBuyNewAvailable) {
                  //console.log("NOT SHOW VARIANT (Buy Use) Out of Stock if we have a BUY NEW available")
                }
              }else if(variants[0].option2 === "Buy New") {
                const buyUsedVariant = product.variants.find(variant => 
                  variant.option2 === "Buy Used" && variant.available === true && variant.option1 === "Print"
                );
                const buyUsedPrice = buyUsedVariant?.price;
                const buyNewPrice = variants[0].price;
                if (buyUsedPrice !== undefined && buyNewPrice !== undefined && buyUsedPrice >= buyNewPrice) {
                  //console.log("NOT SHOW VARIANT (Buy New) same price or higher than (Buy Used)")
                }else{
                  return variants
                    ? await this._renderPurchaseOption(type, variants, product, sectionData)
                    : '';
                }
              }else if(!variants[0].available && variants[0].option2 === "Rent Used"){
                const hasRentNewAvailable = product.variants.some(variant => 
                  variant.option2 === "Rent New" && variant.available === true && variant.option1 === "Print"
                );
                if(!hasRentNewAvailable){
                  //console.log("NOT SHOW VARIANT (Rent USED) both out of stock")
                }else{
                  return variants
                    ? await this._renderPurchaseOption(type, variants, product, sectionData)
                    : '';
                }
              }else if(!variants[0].available && variants[0].option2 === "Rent New"){
                const hasRentUsedAvailable = product.variants.some(variant => 
                  variant.option2 === "Rent Used" && variant.available === true && variant.option1 === "Print"
                );
                const rentUsedPrice = product.variants.find(variant => variant.option2 === "Rent Used" && variant.option1 === "Print")?.price;
                const rentNewPrice = variants[0].price;
                if(!hasRentUsedAvailable){
                  //console.log("NOT SHOW VARIANT (Rent USED) both out of stock")
                }else{
                  if (rentUsedPrice !== undefined && rentNewPrice !== undefined && rentUsedPrice >= rentNewPrice) {
                    //console.log("NOT SHOW VARIANT (Rent New) same price or higher than (Rent Used)")
                  }else{
                    return variants
                      ? await this._renderPurchaseOption(type, variants, product, sectionData)
                      : '';
                  }
                }
              }else if(variants[0].option2 === "Rent New") {
                const rentUsedPrice = product.variants.find(variant => variant.option2 === "Rent Used" && variant.option1 === "Print")?.price;
                const rentNewPrice = variants[0].price;
                if (rentUsedPrice !== undefined && rentNewPrice !== undefined && rentUsedPrice >= rentNewPrice) {
                  //console.log("NOT SHOW VARIANT (Rent New) same price or higher than (Rent Used)")
                }else{
                  return variants
                    ? await this._renderPurchaseOption(type, variants, product, sectionData)
                    : '';
                }
              }else if(variants[0].option2 === "Buy New") {
                const buyUsedVariant = product.variants.find(variant => 
                  variant.option2 === "Buy Used" && variant.available === true && variant.option1 === "Print"
                );
                const buyUsedPrice = buyUsedVariant?.price;
                const buyNewPrice = variants[0].price;
                if (buyUsedPrice !== undefined && buyNewPrice !== undefined && buyUsedPrice >= buyNewPrice) {
                  //console.log("NOT SHOW VARIANT (Buy New) same price or higher than (Buy Used)")
                }else{
                  return variants
                    ? await this._renderPurchaseOption(type, variants, product, sectionData)
                    : '';
                }
              }else{
                return variants
                  ? await this._renderPurchaseOption(type, variants, product, sectionData)
                  : '';
              }
            }
            
          }else{
            return variants
              ? await this._renderPurchaseOption(type, variants, product, sectionData)
              : '';
          }
        })
    );

    return retObj.join('') || this._renderNoOptionsMessage();
  }

  /**
   * @param {any} formatData - Format data
   * @param {Product} product - Product object
   * @returns {string} HTML string
   */
  _renderFormatButton(formatData, product) {
    const productId = product.title.replace(/\s+/g, '-').toLowerCase();
    return `
      <button type="button" class="format-btn" 
              data-format="${formatData.format}" 
              data-product="${productId}">
          <span class="format-label">${formatData.label}</span>
          <span class="format-price">From $${formatData.price}</span>
      </button>
    `;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Default format
   */
  _getDefaultFormat(product) {
    // Get all unique formats and use the first one as default
    const uniqueFormats = this.variantDetector.getUniqueFormats(product);

    if (uniqueFormats.length > 0) {
      return uniqueFormats[0].toLowerCase();
    }

    return null;
  }

  /**
   * @param {Product} product - Product object
   * @returns {string|null} Default format
   */
  _getFormats(product) {
    // Get all unique formats and use the first one as default
    const uniqueFormats = this.variantDetector.getUniqueFormats(product);

    if (uniqueFormats.length > 0) {
      return uniqueFormats;
    }

    return null;
  }

  async fetchMetaobjects(metaobjectType, queryData = '') {
    const proxyPath = '/apps/shopifyData/metaobjects';
    const url = `${proxyPath}?type=${metaobjectType}&query=${encodeURIComponent(queryData)}`;

    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        const activeMetaobjects = result.data.filter(item => item.status === "ACTIVE");
        return activeMetaobjects;
      } else {
        throw new Error(result.error || 'Failed to fetch metaobjects');
      }

    } catch (error) {
      console.error('Error fetching metaobjects:', error);
      throw error;
    }
  }

  /**
   * @param {string} type - Purchase type
   * @param {ProductVariant[]} variants - Variants array
   * @param {Product} product - Product object
   * @returns {string} HTML string
   */
  async _renderPurchaseOption(type, variants, product, sectionData) {
    
    if (!variants || variants.length === 0) return '';

    // Use a Set to track unique IDs
    const uniqueIds = new Set();

    // Filter out duplicates
    const filteredVariants = variants.filter(variant => {
        if (!uniqueIds.has(variant.id)) {
            uniqueIds.add(variant.id); // Add the ID to the Set if it's not already present
            return true; // Keep this variant
        }
        return false; // Discard this variant
    });

    let htmlOutput = '';
    for (const variant of filteredVariants) {
      const price = parseFloat(variant.price).toFixed(2);
      const typeId = type.toLowerCase().replace(/\s+/g, '-');
      const isAvailable = variant.available;
      const productId = product.title.replace(/\s+/g, '-').toLowerCase();

      const availabilityClass = isAvailable ? '' : ' unavailable';
      const disabledAttr = isAvailable ? '' : ' disabled';

      const inBagHTML = window.generateInBagIndicatorHTML?.() || '';

      const variantValueId = variant.id.split("/").pop();

      let typeName = '';

      const bookISBN = variant.metafields.find(metafield => metafield.isbn_ean)?.isbn_ean || '';
      const bookEdition = variant.metafields.find(metafield => metafield.edition)?.edition || '';
      const bookCopyright = variant.metafields.find(metafield => metafield.copyright_year)?.copyright_year || '';
      const bookPublisher = variant.metafields.find(metafield => metafield.publisher_name)?.publisher_name || '';
      const isDigital = variant.metafields.find(metafield => metafield.is_digital)?.is_digital || '';
      const publisher_code = variant.metafields.find(metafield => 
          metafield.publisher_code && metafield.namespace === "course_materials"
      )?.publisher_code || '';
      const isRental = variant.metafields.find(metafield => 
          metafield.is_rental && metafield.namespace === "cm_rental"
      )?.is_rental || '';

      const rental_only_sku = variant.metafields.find(metafield => 
          metafield.rental_only_sku && metafield.namespace === "cm_rental"
      )?.rental_only_sku || '';

      const subscriptionLength = variant.metafields.find(metafield => metafield.subscription)?.subscription || '';

      const taxonomy_dep = variant.metafields.find(metafield => 
          metafield.department && metafield.namespace === "taxonomy"
      )?.department || '';

      const taxonomy_sub_dep = variant.metafields.find(metafield => 
          metafield.sub_department && metafield.namespace === "taxonomy"
      )?.sub_department || '';

      const taxonomy_class = variant.metafields.find(metafield => 
          metafield.class && metafield.namespace === "taxonomy"
      )?.class || '';

      const taxonomy_sub_class = variant.metafields.find(metafield => 
          metafield.sub_class && metafield.namespace === "taxonomy"
      )?.sub_class || '';

      let rental_end_date = '';
      let formattedDate = '';
      if(isRental == "true" && isDigital !== "true"){
        const queryData = "fields.term_id:'"+sectionData.courseInfo.termId+"' fields.disabled_flag:false fields.is_term_open_flag:true"
        const filteredTerms = await this.fetchMetaobjects('ddcs_term', queryData);
        rental_end_date = filteredTerms[0]?.rental_end_date ? filteredTerms[0].rental_end_date : '';
        if(rental_end_date != ''){
          const dateParts = rental_end_date.split('-');
          formattedDate = `${dateParts[1]}/${dateParts[2]}/${dateParts[0]}`;
        }
      }
      if(typeName == ''){
        if(variant.option2 == ''){
          typeName = variant.option1
        }else{
          typeName = variant.option2
        }
      }

        // Determine if this should be a Smart Pick (lowest price option)
        //const isSmartPick = type.toLowerCase().includes('rent') && parseFloat(price) < 50;
        
        // Add question mark icon for BUY USED and RENT USED options (Print format only)
        const isPrintFormat = variant.option1?.toLowerCase() === 'print';
        const showQuestionIcon = isPrintFormat && (type.toLowerCase().includes('buy used') || type.toLowerCase().includes('rent used'));
        const usedTooltipMessage = "Used Materials\n\nMight not include supplemental materials like access cards or CDs.";
        const questionIcon = showQuestionIcon ? `
          <span class="tooltip-trigger" data-tooltip="${usedTooltipMessage}">
            <svg class="question-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
            </svg>
          </span>
        ` : '';

      // Add Smart Pick badge
      //const smartPickBadge = isSmartPick ? '<div class="smart-pick-label">Smart Pick</div>' : '';

      htmlOutput += `
        <div class="purchase-type${availabilityClass}" 
            data-purchase-type="${typeId}" 
            data-variant-id="${variant.id}"
            onclick="window.togglePurchaseOption(this, event)">
            
            <div class="purchase-type-header">
                <div class="purchase-type-label-container">
                    <span class="purchase-type-label">
                        ${typeName.toUpperCase()}
                        ${questionIcon}
                    </span>
                    ${ window.digital_product_config.notice_text && isDigital ? `
                      <anchored-popover-component data-close-on-resize="true" data-close-on-scroll="true" class="notice-tooltip hidden" data-variant-id="${variant.id}">
                        <button ref="trigger" popovertarget="variant-popover-container-${variantValueId}" class="notice-tooltip__icon" popovertargetaction="toggle">
                          <svg class="question-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                          </svg>
                        </button>
                        <div ref="popover" id="variant-popover-container-${variantValueId}" class="notice-tooltip__container" popover="auto">
                          <p>${window.digital_product_config.notice_text}</p>
                        </div>
                      </anchored-popover-component>
                    ` : ''}
                </div>
                ${availabilityClass !== " unavailable" ? `
                <div class="purchase-checkbox-container" onclick="event.stopPropagation()">
                    <input type="checkbox" 
                          id="${typeId}-${productId}-${variantValueId}" 
                          class="purchase-checkbox" 
                          data-format="${variant.option1}"
                          data-type="${typeName}"
                          data-product-id="${variant.parentProductId.split('/').pop()}"
                          data-purchase-type="${typeId}"
                          data-variant-id="${variant.id}"
                          data-variant-price="${price}"
                          data-section-id="${sectionData.courseInfo.selectedsectionId}"
                          data-is-digital="${isDigital}"
                          data-book-isbn="${bookISBN}"
                          data-book-edition="${bookEdition}"
                          data-book-copyright="${bookCopyright}"
                          data-book-publisher="${bookPublisher}"
                          data-publisher-code="${ publisher_code }"
                          data-book-rent-due-date="${formattedDate}"
                          data-product-title="${product.title.replace(/'/g, "\\'")}"
                          data-department-taxonomy="${taxonomy_dep}"
                          data-sub-department="${taxonomy_sub_dep}"
                          data-class="${taxonomy_class}"
                          data-sub-class="${taxonomy_sub_class}"
                          data-rental-only-sku="${rental_only_sku}"
                          data-subscription-length="${subscriptionLength}"
                          onchange="window.handlePurchaseSelection(this)"${disabledAttr}>
                    <label for="${typeId}-${productId}-${variantValueId}" class="checkbox-label"></label>
                </div>
                ` : ''}
            </div>
            
            <div class="purchase-price">$${price}</div>
            

            ${isDigital === "true" ? `
              <div class="" data-format-specific="digital">
                  <button type="button" class="requirements-link" onclick='openRequirementsDialog("${product.title.replace(/'/g, "\\'")}",${JSON.stringify(variant)})'>
                      Requirements
                  </button>
              </div>
          ` : ''}
            ${formattedDate != '' || (subscriptionLength && subscriptionLength != '' && subscriptionLength > 0) ? `
              <div class="rental-duration">${ isDigital === "true" ? "Rental duration:" : "Rental Due"} <span class="days-text">${ isDigital === "true" ? `${subscriptionLength} days` : formattedDate}</span></div>
            `  : '' }
            ${availabilityClass === " unavailable" ? `
              <div class="purchase-price out-of-stock-overlay"> Out of Stock </div>
            ` : ''}
            ${inBagHTML}
        </div>
      `;
    }
    return htmlOutput;
  }

  /**
   * Generate purchase options for simple products (no complex variants)
   * @param {Product} product - Product object
   * @returns {string} HTML string
   */
  async _generateSimpleProductPurchaseOptions(product, sectionData) {
    if (!product.variants || product.variants.length === 0) {
      return this._renderNoOptionsMessage();
    }

    
    const availableVariants = product.variants;

    if (availableVariants.length === 0) {
      return this._renderNoOptionsMessage();
    }

    
    /** @type {Record<string, any[]>} */
    const variantsByType = {};

    availableVariants.forEach(variant => {
      const type = variant.option2 || 'Buy';
      if (!variantsByType[type]) variantsByType[type] = [];
      variantsByType[type].push(variant);
    });

    const purchaseOptions = await Promise.all(
      Object.keys(variantsByType).map(async type => {
        const variants = variantsByType[type];
        return variants
          ? await this._renderPurchaseOption(type, variants, product, sectionData)
          : '';
      })
    );
    return purchaseOptions.join('') || this._renderNoOptionsMessage();
  }

  /**
   * @returns {string} HTML string
   */
  _renderNoOptionsMessage() {
    return `
      <div class="no-options-message" style="text-align: center; padding: 20px; color: #666;">
          <p>No purchase options available for this format.</p>
          <p style="font-size: 0.875rem; margin-top: 8px;">Please try selecting a different format.</p>
      </div>
    `;
  }
}

window.ProductSystem = window.ProductSystem || {};
window.ProductSystem.ShopifyHTMLRenderer = ShopifyHTMLRenderer;